import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Button } from "~/components/Button/Button"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { formatDateNew, isOnlyDate } from "~/helpers/formatDate"
import { getGoogleCalendarLink } from "~/helpers/getGoogleCalendarLink"

import { ButtonsWrapper } from "./components/ButtonsWrapper/ButtonsWrapper"
import styles from "./index.module.css"

export const AddingEventCard: React.FC<{ className?: string; inStockholdersMeeting?: boolean }> = ({
  className,
  inStockholdersMeeting,
}) => {
  const { city, date, link, name, status, ...props } = useApiContext("/calendar/element")
  const { t } = useTranslation()

  if (!date) {
    return null
  }

  if (status !== "active") {
    return null
  }

  return (
    <Card className={cn(className, styles.Wrapper)}>
      {city && (
        <Heading className={styles.City} like="h5">
          <Raw html={city} />
        </Heading>
      )}

      {date && (
        <Heading as="div" like="h3">
          {isOnlyDate(date)
            ? formatDateNew(date, "d MMMM yyyy")
            : formatDateNew(date, "d MMMM, HH:mm")}
        </Heading>
      )}

      {inStockholdersMeeting && (
        <Link
          className={styles.Link}
          href="/investors-and-shareholders/calendar/annual-meeting"
          view="arrow"
        >
          <Raw html={t("AddEventCard.AnnualMeeteng.Link")} />
        </Link>
      )}

      <ButtonsWrapper {...props} />

      <Button
        className={styles.AddToCalendar}
        view="rounded"
        onClick={() => getGoogleCalendarLink(city, name, date, link)}
      >
        <Raw html={t("event.Buttons.AddToCalendar")} />
      </Button>
    </Card>
  )
}
